module.exports = __webpack_public_path__ + "img/m-banner-rvzldswd-id-ID.6b70453c.jpg";